<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/841384205
     */
    const props = defineProps<IWidgetProps<HeroBannerData>>();
    const { cmsComponentProps } = useWidget(props);
</script>

<template>
    <atm-hero-banner
        :component-index="componentIndex"
        v-bind="cmsComponentProps" />
</template>
